export enum ProjectStatusEnum {
  OPEN = 'OPEN',
  SUPPLIER_SELECTED = 'SUPPLIER_SELECTED',
  INSTALLER_SELECTED = 'INSTALLER_SELECTED',
  COMPLETED = 'COMPLETED',
}

/** Statuses shown on the public projects listing. */
export const PUBLIC_PROJECT_STATUSES: ProjectStatusEnum[] = [
  ProjectStatusEnum.OPEN,
  ProjectStatusEnum.SUPPLIER_SELECTED,
  ProjectStatusEnum.INSTALLER_SELECTED,
  ProjectStatusEnum.COMPLETED,
];
